import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  searchBar: {
    padding: '20px 24px',
    boxShadow: palette.shadows.light,
    background: palette.gradients.white,
    display: 'flex',
    marginTop: '32px',
    marginBottom: '40px',
    borderRadius: '2px',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    }
  },
  searchField: {
    flexGrow: '1',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginRight: '0',
      marginBottom: '18px'
    }
  },
  filterSelector: {
    width: '180px',
    '& + &': {
      [breakpointsFunc.breakpoints.up('md')]: {
        marginLeft: '10px'
      },
      [breakpointsFunc.breakpoints.down('md')]: {
        marginTop: '18px'
      }
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  chargesRangeDatePicker: {
    marginLeft: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: '0',
      marginTop: '18px'
    }
  }
});
export default useStyles;